const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Formats any date-ish input (ISO "yyyy-mm-dd" string, a full timestamp string, or a Date) as
 * "dd/MMM/yyyy" (e.g. "25/Sep/2026") — the one date format used everywhere in this app.
 * Returns '' for null/invalid input instead of throwing, so callers can do
 * `{formatDate(x) || '—'}` without a defensive check first.
 */
export function formatDate(input) {
    if (!input) return '';
    const date = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(date.getTime())) return '';
    const dd = String(date.getDate()).padStart(2, '0');
    const mmm = MONTHS[date.getMonth()];
    const yyyy = date.getFullYear();
    return `${dd}/${mmm}/${yyyy}`;
}

/** Same as formatDate but also appends a time (h:mm AM/PM) — for timestamps where the time
 * genuinely matters (e.g. "created at"), not pure calendar dates. */
export function formatDateTime(input) {
    if (!input) return '';
    const date = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(date.getTime())) return '';
    const time = date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
    return `${formatDate(date)}, ${time}`;
}
